import { render, staticRenderFns } from "./recommProduct.vue?vue&type=template&id=57c849bd&scoped=true"
import script from "./recommProduct.vue?vue&type=script&lang=js"
export * from "./recommProduct.vue?vue&type=script&lang=js"
import style0 from "./recommProduct.vue?vue&type=style&index=0&id=57c849bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c849bd",
  null
  
)

export default component.exports